// Services/ExpertServiceLearner.js
import api from "Common/Client/Interceptor";

// Get details of a specific expert service
export const getExpertServiceDetails = async (expertServiceId) => {
  try {
    const response = await api.get(`/indv/ExpertServices/get-by-id/${expertServiceId}`);
    
    return response.data;
  } catch (error) {
    console.error("Error fetching expert service details:", error);
    throw error;
  }
};

// Get purchased expert services for the learner
export const getPurchasedExpertServices = async (params = {}) => {
  try {
    const response = await api.get("/indv/ExpertServicePurchase/Learner/Get-List", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchased expert services:", error);
    throw error;
  }
};